import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export function CircularLoading() {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress />
    </Box>
  );
}

export default CircularLoading;
